"use strict";
/*
    Add here your own custom javascript
*/
const preloadImage = (url) => {
    let img = new Image();
    img.src = url;
    console.info('preloaded: ' + url)
}

const styleAllElements = (elements, styleProperty, styleValue) => {
    for (let x = 0; elements.length > x; x++) {
        elements[x].style[styleProperty] = styleValue
    }
}

// clears text selection
const clearSelection = () => {
    if (window.getSelection) {
        window.getSelection().removeAllRanges();
    } else if (document.selection) {
        document.selection.empty();
    }
}

// tool to make iframe videos max-width
const mediaWrapper = (selector) => {
    const wrap = (toWrap, wrapper) => {
        wrapper = wrapper || document.createElement('div');
        wrapper.classList.add('mediaWrapper')
        toWrap.parentNode.appendChild(wrapper)
        return wrapper.appendChild(toWrap)
    };

    const elements = document.querySelectorAll(selector);

    if (elements.length > 0) {
        elements.forEach((element) => {
            wrap(element)
        })
    }
}

const lightbox = () => {
    let lightboxElement = null;

    const closeLightbox = () => {
        if (this.lightboxElement.style.display !== "none")
            this.lightboxElement.style.display = "none"
    }

    const attachOpenLightboxEvent = (linkElement) => {
        linkElement.addEventListener('click', openLightbox)
    }

    const loadImage = src => new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
    })

    const openLightbox = (event) => {
        let target = event.target
        let imageUrl = target.getAttribute('src')

        // console.log(`imageUrl`, imageUrl)

        this.imageElement = this.lightboxElement.querySelector('.lightbox--image-container img')
        this.imageElement.style.display = "none"
        this.lightboxElement.classList.add('loading')
        this.lightboxElement.style.display = "block"

        loadImage(imageUrl).then(image => {
            // console.log(image, `loaded: ${image.complete}`)
            this.imageElement.src = imageUrl
            this.imageElement.style.display = "block"
            if (this.lightboxElement.classList.contains('loading')) {
                this.lightboxElement.classList.remove('loading')
            }
        })
    }
    return {
        init: () => {
            this.lightboxElement = document.querySelector('div#lightbox')
            this.closeElement = this.lightboxElement.querySelector('button.close')
            this.imageElement = this.lightboxElement.querySelector('img')
            this.imageElement.addEventListener('click', closeLightbox)
            this.closeElement.addEventListener('click', closeLightbox)
            // esc to close
            document.addEventListener('keyup', (e) => {
                if (e.key === "Escape") {
                    closeLightbox()
                }
            })

            let lightboxLinks = document.querySelectorAll("a[data-toggle='lightbox']")
            if (lightboxLinks) {
                lightboxLinks.forEach((linkElement) => {
                    attachOpenLightboxEvent(linkElement)
                })
            }
        }
    }
}

let productColorSlider;

(function () {
    lightbox().init();

    mediaWrapper('iframe[src*=youtube], iframe[src*=vimeo]')

    // Native variant gallery: shared images before the first variant marker remain visible.
    const galleryRoot = document.querySelector('.product-slider-container');
    const mainGallery = galleryRoot?.querySelector('.product-image-slider');
    const thumbGallery = galleryRoot?.querySelector('.product-thumbnail-slider');
    const mainWrapper = mainGallery?.querySelector('.swiper-wrapper');
    const thumbWrapper = thumbGallery?.querySelector('.swiper-wrapper');
    const originalMainSlides = mainWrapper ? Array.from(mainWrapper.children) : [];
    const originalThumbSlides = thumbWrapper ? Array.from(thumbWrapper.children) : [];

    if (mainGallery && thumbGallery && originalMainSlides.length) {
        let productThumbnailSlider = null;
        let productImagesSlider = null;
        let changingSlides = false;

        const createSliders = () => {
            productThumbnailSlider = new Swiper(thumbGallery, {
                direction: 'vertical',
                slidesPerView: 'auto',
                roundLengths: true,
                spaceBetween: 10,
                breakpoints: {
                    0: { direction: 'horizontal', slidesPerView: 'auto', spaceBetween: 8 },
                    992: { direction: 'vertical', slidesPerView: 'auto', spaceBetween: 10 }
                },
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: false,
                mousewheel: true
            });
            productImagesSlider = new Swiper(mainGallery, {
                slidesPerView: 1,
                mousewheel: true,
                roundLengths: true,
                scrollbar: {
                    el: galleryRoot.querySelector('.swiper-scrollbar'),
                    draggable: true
                },
                navigation: {
                    nextEl: galleryRoot.querySelector('.product-image-slider-wrapper .swiper-button-next'),
                    prevEl: galleryRoot.querySelector('.product-image-slider-wrapper .swiper-button-prev')
                }
            });
            const showSlide = index => {
                if (changingSlides || !Number.isInteger(index) || index < 0) return;
                changingSlides = true;
                productImagesSlider.slideTo(index);
                // Keep the thumbnail rail at its current scroll position.
                thumbWrapper.querySelectorAll('.swiper-slide').forEach((slide, i) => {
                    slide.classList.toggle('kore-current-thumbnail', i === index);
                });
                if (productThumbnailSlider && productThumbnailSlider.activeIndex !== index) {
                    productThumbnailSlider.slideTo(index);
                }
                changingSlides = false;
            };
            productThumbnailSlider.on('click', () => showSlide(productThumbnailSlider.clickedIndex));
            // Scrolling the thumbnail rail should not change the main image.
            productImagesSlider.on('slideChange', () => showSlide(productImagesSlider.activeIndex));
            thumbWrapper.querySelectorAll('.swiper-slide').forEach((slide, i) => {
                slide.classList.toggle('kore-current-thumbnail', i === productImagesSlider.activeIndex);
            });
        };
        createSliders();

        const productData = typeof product !== 'undefined' ? product : null;
        const variants = productData?.variants || [];
        const imageKey = url => {
            if (!url) return '';
            const filename = String(url).split('?')[0].split('/').pop() || '';
            try {
                return decodeURIComponent(filename)
                    .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|original|[0-9]+x[0-9]*|x[0-9]+)(?=\.[^.]+$)/i, '')
                    .toLowerCase();
            } catch (error) {
                return filename.toLowerCase();
            }
        };
        const productImages = productData?.images || [];
        const getImageIndex = featured => {
            if (!featured) return -1;
            const id = featured.id || featured.media_id;
            if (id) {
                const direct = originalMainSlides.findIndex(slide => String(slide.dataset.imageId) === String(id));
                if (direct >= 0) return direct;
                const fromProduct = productImages.findIndex(image => image && typeof image === 'object' && String(image.id || image.media_id) === String(id));
                if (fromProduct >= 0) return fromProduct;
            }
            const key = imageKey(typeof featured === 'string' ? featured : (featured.src || featured.url));
            return key ? originalMainSlides.findIndex(slide => imageKey(slide.querySelector('img')?.src) === key) : -1;
        };
        const featuredFor = variant => variant.featured_image || variant.featured_media?.preview_image || variant.featured_media;
        const markerIndices = [...new Set(variants.map(v => getImageIndex(featuredFor(v))).filter(i => i >= 0))].sort((a, b) => a - b);
        let displayedIndices = null;

        const applyVariantGallery = () => {
            if (!markerIndices.length) return;
            const selectedId = document.querySelector('#template-product form input[name="id"]')?.value;
            let selectedVariant = variants.find(v => String(v.id) === String(selectedId));
            // The image gallery can follow a chosen image swatch before the full
            // variant is complete (e.g. Size > Buckle > Inner Belt).
            // This is display-only: the product form still requires every option.
            if (!selectedVariant) {
                const optionGroups = [...document.querySelectorAll('#template-product .product-options > li')];
                const swatchGroupIndex = optionGroups.findIndex(li =>
                    li.querySelector('.product-color-slider'));
                if (swatchGroupIndex >= 0) {
                    const chosen = optionGroups.map(li => {
                        const select = li.querySelector('select.product-option');
                        if (select) return select.value || null;
                        return li.querySelector('input.product-option:checked')?.value || null;
                    });
                    const swatchValue = chosen[swatchGroupIndex];
                    if (swatchValue) {
                        const matching = variants.filter(v =>
                            v.options[swatchGroupIndex] === swatchValue &&
                            chosen.every((value, index) =>
                                !value || index === swatchGroupIndex || v.options[index] === value));
                        // Prefer a matching in-stock variant with a gallery marker,
                        // but allow sold-out options to display their images too.
                        selectedVariant = matching.find(v =>
                            v.available && markerIndices.includes(getImageIndex(featuredFor(v)))) ||
                            matching.find(v => markerIndices.includes(getImageIndex(featuredFor(v)))) ||
                            matching[0] || null;
                    }
                }
            }
            const firstMarker = markerIndices[0];
            let indices;
            if (!selectedVariant) {
                // Initial page: main image, then shared images only.
                indices = originalMainSlides.map((_, i) => i).filter(i => i < firstMarker);
                if (!indices.length) indices = [0];
            } else {
                const start = getImageIndex(featuredFor(selectedVariant));
                if (start < 0 || !markerIndices.includes(start)) {
                    // No marker for this variant: show the main and shared images,
                    // not unrelated variant-specific image groups.
                    indices = originalMainSlides.map((_, i) => i).filter(i => i < firstMarker);
                    if (!indices.length) indices = [0];
                } else {
                    const next = markerIndices.find(i => i > start);
                    const end = next === undefined ? originalMainSlides.length : next;
                    const variantIndices = originalMainSlides.map((_, i) => i).filter(i => i >= start && i < end);
                    // Shared images exclude the initial main image (index 0).
                    const sharedIndices = originalMainSlides.map((_, i) => i).filter(i => i > 0 && i < firstMarker);
                    indices = [...variantIndices, ...sharedIndices];
                }
            }
            if (!indices.length) return;
            if (displayedIndices && displayedIndices.length === indices.length &&
                displayedIndices.every((value, i) => value === indices[i])) return;
            changingSlides = true;
            productImagesSlider.destroy(true, true);
            productThumbnailSlider.destroy(true, true);
            mainWrapper.replaceChildren(...indices.map(i => originalMainSlides[i]));
            thumbWrapper.replaceChildren(...indices.map(i => originalThumbSlides[i]).filter(Boolean));
            displayedIndices = indices;
            createSliders();
            productImagesSlider.slideTo(0, 0);
            productThumbnailSlider.slideTo(0, 0);
            thumbWrapper.querySelectorAll('.swiper-slide').forEach((slide, i) => {
                slide.classList.toggle('kore-current-thumbnail', i === 0);
            });
            changingSlides = false;
        };

        document.addEventListener('change', event => {
            if (event.target.matches('.product-options .product-option')) {
                window.setTimeout(applyVariantGallery, 0);
            }
        });
        document.addEventListener('kore:variant:change', applyVariantGallery);
        window.addEventListener('popstate', () => window.setTimeout(applyVariantGallery, 0));
        applyVariantGallery();
    }

    // Native image swatches: free horizontal swiping on touch devices.
    // Keep this independent of the product image and thumbnail galleries.
    const swatchSliders = document.querySelectorAll('#template-product .product-color-slider');
    const swatchDesktopMedia = window.matchMedia('(min-width: 993px)');
    const swatchInstances = new Map();
    const setupSwatchSliders = () => {
        if (!swatchDesktopMedia.matches) {
            swatchInstances.forEach((instance, element) => {
                instance.destroy(true, true);
                element.classList.remove('kore-swatch-has-more');
            });
            swatchInstances.clear();
            return;
        }
        swatchSliders.forEach(sliderElement => {
            if (swatchInstances.has(sliderElement)) return;
        const swatchWrapper = sliderElement.closest('.product-color-slider-wrapper');
        const swatchSwiper = new Swiper(sliderElement, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            freeModeMomentum: true,
            freeModeMomentumRatio: 0.8,
            freeModeMomentumBounce: false,
            grabCursor: true,
            simulateTouch: true,
            allowTouchMove: true,
            touchStartPreventDefault: false,
            touchReleaseOnEdges: true,
            threshold: 2,
            resistanceRatio: 0.85,
            watchOverflow: true,
            mousewheel: false,
            navigation: {
                nextEl: swatchWrapper?.querySelector('.swiper-button-next'),
                prevEl: swatchWrapper?.querySelector('.swiper-button-prev')
            }
        });
        // A subtle edge fade is visible only while more swatches remain to the right.
        // Swiper handles touch/momentum; this is purely a visual affordance.
        const updateSwatchFade = () => {
            const canScroll = swatchSwiper.allowSlideNext !== false || swatchSwiper.allowSlidePrev !== false;
            const hasOverflow = swatchSwiper.virtualSize > swatchSwiper.width + 2;
            sliderElement.classList.toggle('kore-swatch-has-more', hasOverflow && !swatchSwiper.isEnd);
        };
        swatchSwiper.on('setTranslate', updateSwatchFade);
        swatchSwiper.on('slideChange', updateSwatchFade);
        swatchSwiper.on('reachEnd', updateSwatchFade);
        swatchSwiper.on('fromEdge', updateSwatchFade);
        swatchSwiper.on('resize', updateSwatchFade);
        swatchSwiper.on('update', updateSwatchFade);
        updateSwatchFade();
        swatchInstances.set(sliderElement, swatchSwiper);
        if (!productColorSlider) productColorSlider = swatchSwiper;
        });
    };
    setupSwatchSliders();
    if (swatchDesktopMedia.addEventListener) {
        swatchDesktopMedia.addEventListener('change', setupSwatchSliders);
    } else if (swatchDesktopMedia.addListener) {
        swatchDesktopMedia.addListener(setupSwatchSliders);
    }
    swatchSliders.forEach(sliderElement => {
        const swatchWrapper = sliderElement.closest('.product-color-slider-wrapper');
        sliderElement.querySelectorAll('input[type="radio"]').forEach(input => {
            input.addEventListener('change', () => {
                const selectedText = swatchWrapper?.closest('li')?.querySelector('.product-option-name .selected-option-text');
                if (selectedText) selectedText.textContent = input.value;
            });
        });
    });

    let addonProductSlider = new Swiper('.addon-product-slider', {
        slidesPerView: 'auto',
        // slideToClickedSlide: true,
        spaceBetween: 20,
        // loopedSlides: 50,
        simulateTouch: true,
        allowTouchMove: true,
        touchStartPreventDefault: false,
        touchReleaseOnEdges: true,
        threshold: 6,
        resistanceRatio: 0.85,
        speed: 350,
        breakpoints: {
            0: { spaceBetween: 12 },
            768: { spaceBetween: 20 }
        },
        // Navigation arrows
        navigation: {
            nextEl: document.querySelector(".addon-product-slider-wrapper .swiper-button-next"),
            prevEl: document.querySelector(".addon-product-slider-wrapper .swiper-button-prev")
        }
    });

    // Equalize heights of addon products
    function equalizeAddonProductHeights() {
        const addonProducts = document.querySelectorAll('.addon-product');
        if (!addonProducts.length) return;

        // On mobile, use compact responsive card heights instead of the tallest
        // card across all add-on products (including offscreen slides).
        if (window.matchMedia('(max-width: 767px)').matches) {
            addonProducts.forEach(product => { product.style.height = ''; });
            return;
        }

        // Reset heights to auto first
        addonProducts.forEach(product => {
            product.style.height = 'auto';
        });

        // Find the max height
        let maxHeight = 0;
        addonProducts.forEach(product => {
            const height = product.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Set all elements to the max height
        addonProducts.forEach(product => {
            product.style.height = maxHeight + 'px';
        });
    }

    // Initialize addon product checkbox behavior for select-bar
    function initAddonProductCheckboxes() {
        const addonProducts = document.querySelectorAll('.addon-product');

        addonProducts.forEach(product => {
            const checkbox = product.querySelector('input[name="add_addon"]');

            if (checkbox) {
                // Set initial selected state based on checkbox
                if (checkbox.checked) {
                    product.classList.add('selected');
                } else {
                    product.classList.remove('selected');
                }

                // Add event listener to toggle selected class on parent
                checkbox.addEventListener('change', function() {
                    if (this.checked) {
                        product.classList.add('selected');
                    } else {
                        product.classList.remove('selected');
                    }
                });
            }
        });
    }

    // Call the functions after swiper is initialized
    if (document.querySelector('.addon-product-slider')) {
        // Wait for images to load
        window.addEventListener('load', function () {
            setTimeout(equalizeAddonProductHeights, 100);
            initAddonProductCheckboxes(); // Initialize checkbox behavior
        });

        // Recalculate on window resize
        window.addEventListener('resize', equalizeAddonProductHeights);
    }

    let featuredProductSwiperElement = document.querySelector('.featured-products-carousel')
    if (featuredProductSwiperElement) {
        new Swiper('.featured-products-carousel .swiper', {
            // Optional parameters
            direction: "horizontal",
            loop: false,
            autoplay: false,
            slidesPerView: 3,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                // when window width is >= 640px
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                // when window width is >= 1680px
                1680: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            },
            // Navigation arrows
            navigation: {
                nextEl: featuredProductSwiperElement.querySelector(".swiper-button-next"),
                prevEl: featuredProductSwiperElement.querySelector(".swiper-button-prev")
            }
        })
    }

    const navBarOffCanvas = document.querySelector('#navbar-offcanvas')
    const toggler = document.querySelector('#navbar .navbar-toggler')
    navBarOffCanvas.addEventListener('show.bs.offcanvas', event => {
        if (!toggler.classList.contains('active')) {
            toggler.classList.add('active')
        }
    })
    navBarOffCanvas.addEventListener('hide.bs.offcanvas', event => {
        if (toggler.classList.contains('active')) {
            toggler.classList.remove('active')
        }
    })

    // auto play and auto pause for home video modal
    const iframe = document.getElementById('home--video-modal-iframe');
    const homeVideoModal = document.getElementById('home--video-modal')
    if (homeVideoModal) {
        homeVideoModal.addEventListener('shown.bs.modal', event => {
            // only auto play when on desktop
            if (window.innerWidth >= 992) {
                iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            }
        })
        homeVideoModal.addEventListener('hidden.bs.modal', event => {
            iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        })
    }

})();

/**
 * Implements dynamic form validation for '.form-wholesale'.
 * Validates fields based on 'data-validations' attribute,
 * applying 'error' class on validation failure. Prevents
 * form submission if any validation fails, focusing the first
 * invalid field. Supports comma-separated validation rules
 * like 'required', 'email', etc. Now also supports 'required'
 * validation for select fields, ensuring a selection is made.
 */
document.addEventListener('DOMContentLoaded', function () {
    const insightlyWholesaleForm = document.querySelector('.form-wholesale');

    if (insightlyWholesaleForm) {
        insightlyWholesaleForm.addEventListener('submit', function (event) {
            const controls = insightlyWholesaleForm.querySelectorAll('[data-validations]');
            let isFormValid = true;

            controls.forEach(control => {
                const validations = control.dataset.validations.split(',').map(v => v.trim());
                let isFieldValid = true;

                // Initially remove the 'error' class to reset the state from previous checks
                control.classList.remove('error');

                for (let validation of validations) {
                    if (!validateField(control, validation)) {
                        // If validation fails, add 'error' class and mark field and form as invalid
                        control.classList.add('error');
                        isFieldValid = false;
                        isFormValid = false;
                        break; // Exit the validation loop on the first failure
                    }
                }
            });

            if (!isFormValid) {
                event.preventDefault(); // Prevent form submission if there are invalid fields
                // Optional: Focus the first invalid field for user convenience
                insightlyWholesaleForm.querySelector('.error')?.focus();
            }
        });
    }
});

function validateField(field, validationType) {
    switch (validationType) {
        case 'required':
            if (field.type === 'select-multiple') {
                // For multi-select, check if any option is selected
                return Array.from(field.options).some(option => option.selected);
            }
            return field.value.trim() !== '';
        case 'email':
            return /^.+\@.+\..+$/.test(field.value);
        default:
            return true; // Assume field is valid if the validation type is unknown
    }
}

// Attaches an event to the search form to format user input into
// exact phrase search queries by enclosing the input in quotes.
document.addEventListener('DOMContentLoaded', function () {
    const searchForm = document.querySelector('#template-search');
    if (searchForm) {
        const searchInput = searchForm.querySelector('input[name="q"]');

        searchForm.addEventListener('submit', function (event) {
            let searchTerms = searchInput.value.trim();

            // Strip existing enclosing quotes
            searchTerms = searchTerms.replace(/^"|"$/g, '');

            // Enclose the search terms in quotes
            searchTerms = `"${searchTerms}"`;

            searchInput.value = searchTerms;

            // No need to explicitly call event.preventDefault() as we want the form to submit
            // The form will naturally submit with the modified search terms
        });
    }
});

/* ALEX-SWATCHES: collection card image swatches (delegated for dynamic grids). */
document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.kore-card-swatch');
  if (!swatch) return;
  event.preventDefault();
  event.stopPropagation();
  const card = swatch.closest('.product-item');
  if (!card) return;
  const mainImage = card.querySelector('[data-kore-card-main-image]');
  const productLink = card.querySelector('.kore-card-product-link');
  if (mainImage && swatch.dataset.koreCardImage) {
    mainImage.src = swatch.dataset.koreCardImage;
    mainImage.removeAttribute('srcset');
    mainImage.alt = swatch.dataset.koreCardAlt || mainImage.alt;
  }
  if (productLink && swatch.dataset.koreCardUrl) {
    productLink.href = swatch.dataset.koreCardUrl;
  }
  card.querySelectorAll('.kore-card-swatch').forEach(function (button) {
    const selected = button === swatch;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });
});

/* ALEX-SWATCHES: collection swatch arrows, clamped to actual scroll boundaries. */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.product-item .kore-card-swatches:not([data-kore-arrows-ready])').forEach(function (strip) {
      strip.dataset.koreArrowsReady = 'true';
      var wrapper = document.createElement('div');
      wrapper.className = 'kore-card-swatch-navigation';
      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = next.className = 'kore-card-swatch-arrow';
      prev.textContent = '\u2039'; next.textContent = '\u203a';
      prev.setAttribute('aria-label', 'Previous swatches');
      next.setAttribute('aria-label', 'Next swatches');
      strip.parentNode.insertBefore(wrapper, strip);
      wrapper.append(prev, strip, next);
      function update() {
        var max = Math.max(0, strip.scrollWidth - strip.clientWidth);
        wrapper.classList.toggle('kore-card-swatches-fit', max <= 3);
        var atStart = strip.scrollLeft <= 3;
        var atEnd = strip.scrollLeft >= max - 3;
        prev.disabled = atStart;
        next.disabled = atEnd || max <= 3;
        prev.hidden = atStart;
        next.hidden = atEnd || max <= 3;
      }
      function move(direction) {
        var max = Math.max(0, strip.scrollWidth - strip.clientWidth);
        var item = strip.querySelector('.kore-card-swatch');
        var step = item ? item.getBoundingClientRect().width + 8 : 60;
        var target = Math.max(0, Math.min(max, strip.scrollLeft + direction * step * 3));
        strip.scrollTo({left: target, behavior: 'smooth'});
      }
      prev.addEventListener('click', function (event) { event.preventDefault(); if (!prev.disabled) move(-1); });
      next.addEventListener('click', function (event) { event.preventDefault(); if (!next.disabled) move(1); });
      strip.addEventListener('scroll', update, {passive: true});
      window.addEventListener('resize', update);
      /* The initial position must be zero, even when browser scroll restoration occurs. */
      strip.scrollLeft = 0;
      update();
      window.requestAnimationFrame(function () { strip.scrollLeft = 0; update(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();